import BuildingType from "@/roc/building/BuildingType";
import Effects from '@/roc/effects/Effects';
import ProductionOutputType from '@/roc/effects/Production/ProductionOutputType';
import PassiveProduction from '@/roc/effects/Production/PassiveProduction';
import ProductionDuration from '@/roc/effects/Production/ProductionDuration';
import ProductionOutput from '@/roc/effects/Production/ProductionOutput';
import PassiveAura from '@/roc/effects/PassiveAura/PassiveAura';
import PassiveAuraType from '@/roc/effects/PassiveAura/PassiveAuraType';
import EffectAmount from '@/roc/effects/EffectAmount';
import CultureBonus from '@/roc/effects/CultureBonus/CultureBonus';
import CultureAmount from '@/roc/effects/CultureBonus/CultureAmount';
import CultureRange from '@/roc/effects/CultureBonus/CultureRange';

const ElysianField = {
  id: "63",
  name: "Elysian Field",
  width: 5,
  height: 3,
  type: BuildingType.EVENT,
  era: "stoneAge",
  icon: "Elysian_Field",
  minLevel: 1,
  maxLevel: 60,
  url: 'https://riseofcultures.wiki.gg/wiki/Buildings/Elysian_Field',
  flags: 0,
  counts: null,
  effects: Effects.create([
    new PassiveProduction(
      ProductionDuration.asDaily(),
      ProductionOutput.asPerLevel([
        1.5, 1.5, 1.7, 1.7, 1.7, 1.9, 1.9, 1.9, 2.1, 2.1,
        2.1, 2.3, 2.3, 2.5, 2.5, 2.7, 2.7, 2.9, 2.9, 3.1,
        3.1, 3.1, 3.1, 3.3, 3.3, 3.5, 3.5, 3.7, 3.7, 3.9,
        3.9, 3.9, 4.1, 4.1, 4.1, 4.3, 4.3, 4.5, 4, 4,
        5, 5, 5, 5, 5, 5, 6, 6, 6, 6,
        6, 6, 7, 7, 7, 7, 7, 7, 8, 8
      ]).withOutput(ProductionOutputType.RESEARCH_POINTS),
    ),
    new PassiveAura(
      PassiveAuraType.LIGHT_INFANTRY_HIT_POINT_MOD,
      EffectAmount.asPerLevel([
        0.0, 0.0, 0.0, 1.5, 1.5, 1.5, 1.5, 2.0, 2.0, 2.0,
        2.5, 2.5, 2.5, 2.5, 3.5, 3.5, 3.5, 3.5, 4.0, 4.0,
        4.0, 4.5, 4.5, 4.5, 4.5, 4.5, 5.5, 5.5, 5.5, 5.5,
        6.0, 6.0, 6.0, 6.0, 6.5, 6.5, 7.5, 7.5, 7.5, 8.0,
        8.1, 8.2, 8.3, 8.4, 8.5, 8.6, 8.7, 8.8, 8.9, 9.0,
        9.1, 9.2, 9.3, 9.4, 9.5, 9.6, 9.7, 9.8, 9.9, 10.0
      ]),
      '%',
    ),
    new CultureBonus(
      CultureAmount.asPerEraAndLevel({
        stoneAge: [
          10, 25, 25, 25, 57, 57, 80, 80, 80, 111, 111, 111, 127, 127, 127, 127,
          142, 142, 142, 142, 155, 155, 168, 168, 181, 181, 181, 181, 192, 192,
          192, 204, 204, 215, 215, 215, 215, 215, 225, 227, 229, 231, 233, 235,
          237, 239, 241, 243, 245, 247, 249, 251, 253, 255, 257, 259, 261, 263,
          265, 267,
        ],
        bronzeAge: [
          12, 30, 30, 30, 69, 69, 96, 96, 96, 133, 133, 133, 152, 152, 152, 152,
          170, 170, 170, 170, 186, 186, 202, 202, 217, 217, 217, 217, 231, 231,
          231, 244, 244, 258, 258, 258, 258, 258, 270, 272, 274, 276, 279, 281,
          284, 286, 288, 291, 293, 296, 298, 300, 303, 305, 308, 310, 312, 315,
          317, 320,
        ],
        minoanEra: [
          15, 35, 35, 35, 80, 80, 112, 112, 112, 155, 155, 155, 178, 178, 178,
          178, 198, 198, 198, 198, 217, 217, 236, 236, 253, 253, 253, 253, 269,
          269, 269, 285, 285, 301, 301, 301, 301, 301, 315, 318, 320, 323, 326,
          329, 332, 334, 337, 340, 343, 346, 348, 351, 354, 357, 360, 362, 365,
          368, 371, 374,
        ],
        classicGreece: [
          18, 40, 40, 40, 92, 92, 129, 129, 129, 178, 178, 178, 203, 203, 203,
          203, 227, 227, 227, 227, 249, 249, 269, 269, 289, 289, 289, 289, 308,
          308, 308, 326, 326, 343, 343, 343, 343, 343, 360, 363, 366, 369, 373,
          376, 380, 383, 386, 390, 393, 397, 400, 403, 407, 410, 414, 417, 420,
          424, 427, 431,
        ],
        earlyRome: [
          21, 45, 45, 45, 103, 103, 145, 145, 145, 200, 200, 200, 228, 228, 228,
          228, 255, 255, 255, 255, 280, 280, 303, 303, 325, 325, 325, 325, 346,
          346, 346, 367, 367, 386, 386, 386, 386, 386, 405, 409, 412, 416, 420,
          424, 428, 431, 435, 439, 443, 447, 450, 454, 458, 462, 466, 469, 473,
          477, 481, 485,
        ],
        romanEmpire: [
          25, 50, 50, 50, 115, 115, 161, 161, 161, 222, 222, 222, 254, 254, 254,
          254, 283, 283, 283, 283, 311, 311, 337, 337, 361, 361, 361, 361, 385,
          385, 385, 407, 407, 429, 429, 429, 429, 429, 450, 454, 458, 462, 466,
          470, 475, 479, 483, 487, 491, 496, 500, 504, 508, 512, 517, 521, 525,
          529, 533, 538,
        ],
        byzantineEra: [
          30, 55, 55, 55, 126, 126, 177, 177, 177, 244, 244, 244, 279, 279, 279,
          279, 312, 312, 312, 312, 342, 342, 370, 370, 397, 397, 397, 397, 423,
          423, 423, 448, 448, 472, 472, 472, 472, 472, 495, 500, 504, 509, 513,
          518, 523, 527, 532, 536, 541, 546, 550, 555, 559, 564, 569, 573, 578,
          582, 587, 592,
        ],
        ageOfTheFranks: [
          35, 60, 60, 60, 138, 138, 193, 193, 193, 266, 266, 266, 305, 305, 305,
          305, 340, 340, 340, 340, 373, 373, 404, 404, 433, 433, 433, 433, 462,
          462, 462, 489, 489, 515, 515, 515, 515, 515, 540, 545, 550, 555, 560,
          565, 570, 575, 580, 585, 590, 595, 600, 605, 610, 615, 620, 625, 630,
          635, 640, 645,
        ],
        feudalAge: [
          40, 65, 65, 65, 149, 149, 209, 209, 209, 289, 289, 289, 330, 330, 330,
          330, 368, 368, 368, 368, 404, 404, 438, 438, 470, 470, 470, 470, 500,
          500, 500, 530, 530, 558, 558, 558, 558, 558, 586, 592, 597, 603, 608,
          614, 620, 625, 631, 636, 642, 648, 653, 659, 664, 670, 676, 681, 687,
          692, 698, 704,
        ],
        iberianEra: [
          45, 105, 105, 105, 180, 180, 220, 220, 220, 275, 275, 275, 320, 320,
          320, 320, 375, 375, 375, 375, 425, 425, 450, 450, 475, 475, 475, 475,
          515, 515, 515, 550, 550, 570, 570, 570, 570, 570, 620, 628, 636, 644,
          652, 660, 668, 676, 684, 692, 700, 708, 716, 724, 732, 740, 748, 756,
          764, 772, 780, 788,
        ],
        kingdomOfSicily: [
          50, 110, 110, 110, 195, 195, 235, 235, 235, 295, 295, 295, 340, 340,
          340, 340, 405, 405, 405, 405, 455, 455, 480, 480, 505, 505, 505, 505,
          555, 555, 555, 590, 590, 610, 610, 610, 610, 610, 660, 670, 680, 690,
          700, 710, 720, 730, 740, 750, 760, 770, 780, 790, 800, 810, 820, 830,
          840, 850, 860, 870,
        ],
        highMiddleAges: [
          54, 119, 119, 119, 211, 211, 254, 254, 254, 319, 319, 319, 367, 367,
          367, 367, 437, 437, 437, 437, 491, 491, 518, 518, 545, 545, 545, 545,
          599, 599, 599, 637, 637, 659, 659, 659, 659, 659, 713, 728, 740, 752,
          764, 776, 789, 801, 813, 825, 837, 850, 862, 874, 886, 898, 911, 923,
          935, 947, 959, 972,
        ],
        earlyGothicEra: [
          56, 123, 123, 123, 219, 219, 266, 266, 266, 335, 335, 335, 388, 388,
          388, 388, 465, 465, 465, 465, 525, 525, 555, 555, 585, 585, 585, 585,
          646, 646, 646, 689, 689, 659, 714, 714, 714, 714, 776, 790, 804, 818,
          832, 846, 860, 874, 888, 902, 916, 930, 944, 958, 972, 986, 1000, 1014,
          1028, 1042, 1056, 1070,
        ],
        lateGothicEra: [
          0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0
        ]
      }),
      CultureRange.asPerLevel([
        1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 2, 2, 2, 2, 2,
        2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3,
        3, 3, 3, 3, 3, 3, 3, 3, 3, 4,
      ]),
    ),
  ]),
};

export default ElysianField;
